import { Injectable, inject } from '@angular/core';
import { EnvironmentConfig } from '../environment-config';

@Injectable({
    providedIn: 'root',
})
export class ErrorReporter {
    private readonly env = inject(EnvironmentConfig);

    private hasOriginalError(x: unknown): x is { originalError: unknown } {
        return typeof x === 'object' && x !== null && 'originalError' in x;
    }

    reportError(err: unknown) {
        if (this.hasOriginalError(err)) {
            console.error(err.originalError);
        } else {
            console.error(err);
        }
    }
}
